import { createModalStore } from '@/shared/lib/modal';

export const useRecordingMinutesPaywallStore = createModalStore();
